export default __webpack_public_path__ + "static/media/LANDING5.6c49dba1.jpg";